import { List } from "immutable";
import { loadingAsyncState } from "widgets-for-react";
import { fixMediaUrl, processRichText } from "../../Shared/api/drupal/drupalApi";
import { DrupalEmbedToVideo, DrupalMediaToVideo } from "../../Shared/api/drupal/nodeConversionHelpers";
import { getTeasers } from "../../Shared/api/elasticsearch/elasticsearchApi";
import { loadFormstackForm } from "../custom_components/components/formstack/formstack_api";
export const richTextBlock = (p)=>({
        kind: "richText",
        title: p.field_title,
        html: p.field_rich_text ? processRichText(p.field_rich_text) : "",
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : "",
        secondaryActionTitle: p.field_secondary_action ? p.field_secondary_action.title : "",
        secondaryActionUrl: p.field_secondary_action ? p.field_secondary_action.url : "",
        media: p.field_inline_media ? {
            media: mediaBlock(p.field_inline_media),
            position: p.field_inline_media.field_position == "text_left" ? "text_left" : "text_right"
        } : "none"
    });
export const mediaBlock = (p)=>{
    return p.field_media.bundle == "video" ? {
        kind: "video",
        video: DrupalMediaToVideo(p)
    } : {
        kind: "image",
        imageUrlSmall: fixMediaUrl(p.field_media.field_media_image.image.style_urls["400w"]),
        imageUrl: fixMediaUrl(p.field_media.field_media_image.image.style_urls["800w"]),
        imageUrlFallback: fixMediaUrl(p.field_media.field_media_image.image.style_urls["800w_fb"]),
        imageUrlLarge: fixMediaUrl(p.field_media.field_media_image.image.style_urls["1600w"]),
        imageAlt: p.field_media.field_media_image.alt
    };
};
export const faqBlock = (p)=>({
        kind: "faq",
        title: p.field_faq_title,
        entries: p.field_faq_item.map((i)=>({
                question: i.label,
                answer: i.field_answer ? processRichText(i.field_answer) : ""
            })).toList()
    });
export const highlightBlock = (p)=>({
        kind: "highlight",
        title: p.field_title,
        subtitle: p.field_subtitle,
        content: p.field_rich_text
    });
export const buttonBlock = (p)=>({
        kind: "knop",
        caption: p.field_link.title,
        href: p.field_link.url
    });
export const imagesBlock = (p)=>({
        kind: "images",
        images: p.field_images.reduce((l, i)=>l.push({
                imageAlt: i.field_media_image.alt,
                imageUrlSmall: fixMediaUrl(i.field_media_image.image.style_urls["420x320"]),
                imageUrl: fixMediaUrl(i.field_media_image.image.style_urls["840x640"]),
                imageUrlFallback: fixMediaUrl(i.field_media_image.image.style_urls["4x3"]),
                imageUrlLarge: fixMediaUrl(i.field_media_image.image.style_urls["840x640"]),
                imageUrlExtraLarge: fixMediaUrl(i.field_media_image.image.url)
            }), List())
    });
export const vacancyOverviewBlock = (p)=>{
    var _p_field_category;
    return {
        kind: "vacancy_overview",
        title: p.field_title,
        html: p.field_rich_text,
        placeholder: p.field_placeholder_text,
        category_id: ((_p_field_category = p.field_category) === null || _p_field_category === void 0 ? void 0 : _p_field_category.id) ?? null
    };
};
export const booksOverviewBlock = (p)=>({
        kind: "books",
        books: p.field_books.map((b)=>({
                title: b.field_title,
                author: b.field_author,
                imageUrl: fixMediaUrl(b.field_image.field_media_image.image.style_urls["195x195"]),
                imageUrlFallback: fixMediaUrl(b.field_image.field_media_image.image.style_urls["1x1"]),
                imageUrlLarge: fixMediaUrl(b.field_image.field_media_image.image.style_urls["390x390"]),
                imageAlt: b.field_image.field_media_image.alt,
                url: b.field_link.url
            })).toList(),
        title: p.field_title,
        text: p.field_text
    });
export const featuredContentBlock = (p)=>({
        kind: "featured_content",
        title: p.field_title,
        html: p.field_rich_text,
        imageUrl: fixMediaUrl(p.field_image.field_media_image.image.style_urls["470x470"]),
        imageUrlFallback: fixMediaUrl(p.field_image.field_media_image.image.style_urls["1x1"]),
        imageUrlLarge: fixMediaUrl(p.field_image.field_media_image.image.style_urls["940x940"]),
        imageAlt: p.field_image.field_media_image.alt,
        linkTitle: p.field_link.title,
        linkUrl: p.field_link.url
    });
export const activityClusterBlock = (p)=>({
        kind: "activity_cluster",
        title: p.field_title,
        description: p.field_text,
        slug: "",
        activitySummariesIds: p.field_product_db_ids
    });
export const subscriptionsBlock = (p)=>({
        kind: "subscription_block",
        items: p.field_subscription_item.reduce((l, i)=>l.push({
                title: i.field_title,
                price: i.field_price,
                sticker: i.field_sticker ? i.field_sticker : "",
                extra: i.field_text ? i.field_text : "",
                materials: i.field_materials,
                services: i.field_services ? i.field_services : "",
                linkTitle: i.field_link.title,
                linkUrl: i.field_link.url,
                isYouth: i.field_is_youth
            }), List())
    });
export const contentGridBlock = (p)=>({
        kind: "content_grid",
        items: p.field_content_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                subtitle: i.field_subtitle ? i.field_subtitle : "",
                label: i.field_label ? i.field_label : "",
                imageAlt: i.bundle == "content_grid_item" ? i.field_image.field_media_image.alt : "",
                imageUrl: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["420x320"]) : "",
                imageUrlFallback: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["4x3"]) : "",
                imageUrlLarge: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["840x640"]) : "",
                video: i.bundle == "content_grid_video" ? DrupalEmbedToVideo(i.field_video, i.field_title) : undefined,
                linkUrl: i.field_link ? i.field_link.url : ""
            }), List())
    });
export const recentNewsBlock = (p)=>({
        kind: "recent_news",
        title: p.field_title,
        count: p.field_count,
        linkTitle: p.field_link && p.field_link.title,
        linkUrl: p.field_link && p.field_link.url
    });
export const carouselContentGridBlock = (p)=>({
        kind: "carousel_content_grid",
        title: p.field_title,
        items: p.field_content_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                subtitle: i.field_subtitle ? i.field_subtitle : "",
                label: i.field_label ? i.field_label : "",
                imageAlt: i.bundle == "content_grid_item" ? i.field_image.field_media_image.alt : "",
                imageUrl: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["420x320"]) : "",
                imageUrlFallback: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["4x3"]) : "",
                imageUrlLarge: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["840x640"]) : "",
                video: i.bundle == "content_grid_video" ? DrupalEmbedToVideo(i.field_video, i.field_title) : undefined,
                linkUrl: i.field_link.url
            }), List()),
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : ""
    });
export const pageGridBlock = (p)=>({
        kind: "async_block",
        promise: ()=>getTeasers(p.field_page_grid_items.map((i)=>i.id.toString()).toArray()),
        block: (teasers)=>({
                kind: "content_grid",
                title: p.field_title,
                items: teasers.map((t)=>({
                        title: t.title,
                        linkUrl: t.url,
                        imageAlt: t.imageAlt,
                        imageUrl: t.imageUrl,
                        imageUrlFallback: t.imageUrl,
                        imageUrlLarge: t.imageUrlLarge,
                        subtitle: t.description
                    })).toList(),
                primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : undefined,
                primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : undefined
            })
    });
export const quoteBlock = (p)=>{
    return {
        kind: "quote",
        quote: p.field_quote_text,
        source: p.field_quote_source && p.field_quote_source != "" ? p.field_quote_source : undefined
    };
};
export const collectionSearchBarBlock = (p)=>{
    return {
        kind: "collection_search_bar"
    };
};
export const gridBlock = (p)=>{
    return {
        kind: "grid_block",
        title: p.field_title,
        row_count: p.field_row_count ? p.field_row_count : 3,
        items: p.field_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                imageAlt: i.field_media.field_media_image.alt,
                imageUrl: fixMediaUrl(i.field_media.field_media_image.image.style_urls['420x320']),
                imageUrlFallback: fixMediaUrl(i.field_media.field_media_image.image.style_urls['4x3']),
                imageUrlLarge: fixMediaUrl(i.field_media.field_media_image.image.style_urls['840x640']),
                intro: i.field_text,
                linkUrl: i.field_link.url
            }), List())
    };
};
export const formstackBlock = (p)=>{
    return {
        kind: p.bundle,
        formId: p.field_formstack_form_id,
        state: loadingAsyncState(()=>loadFormstackForm(p.field_formstack_form_id))
    };
};
export const panoramaBlock = (p)=>{
    console.log('p', p);
    return {
        kind: "panorama",
        imageUrl: fixMediaUrl(p.field_image.field_media_image.image.url)
    };
};
export const emptyBlock = (block)=>{
    console.warn("Unable to convert block:", block.bundle);
    return {
        kind: "empty"
    };
};
